export default {
  namespaced: true,
  state: {
    routerMenu: []
  },
  mutations: {
    SET_ROUTERMENU: function SET_ROUTERMENU(state, routes) {
      state.routerMenu = routes;
    }
  },
  actions: {
    setRouters: function setRouters(_ref, routes) {
      var commit = _ref.commit;
      commit('SET_ROUTERMENU', routes);
    }
  }
};